angular.module('impactx.catalog').controller('BudgetImportController', [
    '$scope',
    'dataGen',
    'ToastService',
    '$mdDialog',
    'TranslationService',
    BudgetImportController
]);

function BudgetImportController($scope, dataGen, ToastService, $mdDialog, TranslationService) {
    var ctrl = this;

    $scope.uploadFile = {};
    $scope.cancelLabel = TranslationService.get("abort");
    
    ctrl.import = function () {
        $scope.uploadInProgress = true;
        var paramObj = {
            file: $scope.uploadFile.file
        };
        dataGen.uploadFile(paramObj, ctrl.entryPoint, true).then(function () {
            $scope.uploadInProgress = false;
            $mdDialog.hide();
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        }, function () {
            $scope.uploadInProgress = false;
        });
    };

    ctrl.cancel = function () {
        $mdDialog.cancel();
    }

}